import { EventSeriesOrderData } from '@beat-venues/common-types';
import { Spinner } from '@beat-venues/ui/react';
import { useQuery } from '@tanstack/react-query';
import React, { ComponentType, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { UserContext } from '../context/user-context';
import { useTransactionsStore } from '../states/transaction-state';

export interface WithTransactionProps {
    transactions: EventSeriesOrderData[];
    isPending: boolean;
}

const withTransaction = <P extends WithTransactionProps>(
    WrappedComponent: ComponentType<P>
) => {
    const WithTransactionHOC: React.FC<Omit<P, keyof WithTransactionProps>> = (
        props
    ) => {
        const { transactions, setTransactions } = useTransactionsStore();
        const { i18n } = useTranslation();
        const { user } = useContext(UserContext);
        const userId = user?.sfContactId;

        const { isPending } = useQuery({
            queryKey: ['my-upcoming-events', i18n.language],
            queryFn: async () => {
                const result = await fetch(
                    `/api/events/${userId}?lang=${i18n.language}`
                ).then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else return [];
                });
                setTransactions(result);
                return '200 OK';
            },
            enabled: !!userId,
            staleTime: Infinity,
        });

        if (isPending) return <Spinner className="mb-16" venueId="beat" />;

        return (
            <WrappedComponent
                {...(props as P)}
                isPending={true}
                transactions={transactions}
            />
        );
    };

    return WithTransactionHOC;
};

export default withTransaction;
